export default __webpack_public_path__ + "static/media/img_teacher.bda666e5.png";